export enum StructureType {
  GROUP = 'GROUP',
  COMPANY = 'COMPANY',
  BRANCH = 'BRANCH',
}
